import { useState } from "react";
import { db } from "../../Environment/firebase";
import firebase from "firebase/compat/app";
import { useAuthContext } from "../../Modules/Auth/AuthContext";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormLabel from "@mui/material/FormLabel";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Avatar from '@mui/material/Avatar';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { Card } from '@mui/material';
import { CardContent } from '@mui/material';
import { FormControl } from "@mui/material";
import { InputLabel } from "@mui/material";
import  Select,{ SelectChangeEvent } from "@mui/material/Select";
import { MenuItem } from "@mui/material";
import FormHelperText from '@mui/material/FormHelperText';
import { Navigate } from "react-router";
import { grades, departments,prefectures,media } from "../../Environment/Config";

export function LoginForms() {

  const { user, userExist } = useAuthContext();

  const uid:string = user?.uid || '';
  const provider:string = user?.providerData[0]?.providerId || '';
  const email:string = user?.email || '';
  const displayName:string = user?.displayName || '';
  const photoURL:string = user?.photoURL || '';

  const [read, setRead] = useState<boolean>(false);
  const [status, setStatus] = useState<boolean>(false);
  const [nickname, setNickname] = useState<string | null>(null);
  const [position, setPosition] = useState<string>('');
  const [belongs, setBelongs] = useState<string>('');
  const [grade, setGrade] = useState<number>(0);
  const [prefecture,setPrefecture] = useState<number>(0);
  const [department, setDepartment] = useState<number>(0);
  const [mediaKind,setMediaKind] = useState<string[]>([]);
  const [magazine, setMagazine] = useState<boolean>(false);
  const [warning, setWarning] = useState<boolean>(false);
  const [loading,setLoading] =  useState<boolean>(false);

  const checkread = () => {
    setRead(true);
  };

  const checkstatus = () => {
    setStatus(!status);
  };

  const handleGrade = (event:SelectChangeEvent) => {
    setGrade(parseInt(event.target.value as string))
  }

  const handlePrefecture = (event:SelectChangeEvent) => {
    setPrefecture(parseInt(event.target.value as string))
  }

  const handleDepartment = (event:SelectChangeEvent) => {
    setDepartment(parseInt(event.target.value as string))
  }

  const handleMedia = (element:string) => {
    var KindArray = mediaKind
    if (KindArray.indexOf(element)!==-1){
      const n = KindArray.indexOf(element);
      KindArray.splice(n,1);
    }else{
      KindArray.push(element)
    }
    setMediaKind(KindArray)
    setLoading(!loading)
  }

  const data = {
    uid: uid,
    nickname: nickname,
    position: position,
    belongs: belongs,
    provider: provider,
    displayName: displayName,
    photoURL: photoURL,
    email: email,
    agree: status,
    grade: grade,
    prefecture:prefecture,
    department: department,
    magazine: magazine,
    media:mediaKind,
    userStatus: 'normal',
    createTime: firebase.firestore.FieldValue.serverTimestamp()
  };

  type UserDataType = {
    uid: string,
    nickname: string | null,
    position: string,
    belongs: string,
    provider: string,
    displayName: string,
    photoURL: string,
    email: string,
    agree: boolean,
    grade: number,
    prefecture:number,
    department: number,
    magazine: boolean,
    media:any[],
    userStatus: string,
    createTime: firebase.firestore.FieldValue
  }

  const createUser = (data:UserDataType) => {
    if (position !== '' && 
        belongs !== '' && 
        prefecture!==0 && 
        mediaKind.length>0) {
      db.collection("users")
        .doc(uid)
        .set(data)
        .then(() => {
          window.location.href = "/";
          console.log("Document successfully written!");
          return <div>Document successfully written!</div>;
        })
        .catch((err:string) => {
          console.log("error:", err);
        });
    } else {
      setWarning(true)
    }
  };

  return (
    <div>
      {userExist===true ? (
        <div>
          <h3>Loading...</h3>
          <Navigate to="/" ></Navigate>
        </div>
      ) : (
        <div>
          <Container component="main" maxWidth='sm' sx={{ mt: 3 }}>
            <Card sx={{ mt: 3 }} >
              <CardContent>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                    <LockOutlinedIcon />
                  </Avatar>
                  <Typography component="h1" variant="h4">
                    お客様情報登録フォーム
                  </Typography>
                  <Typography component="h1" variant="h6">
                    お客様の、アカウント登録はまだ完了しておりません。
                  </Typography>
                  <Typography component="div" variant="subtitle1" sx={{ mt: 2 }}>
                    以下のサービスをご利用するにはアカウント登録が必要です。
                  </Typography>
                  <Grid item sx={{
                    marginTop: 3,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'left',
                  }}>
                    <Typography component="h5" variant="h5">
                      ・Basic
                    </Typography>
                  </Grid>
                  <div>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          id="outlined-required"
                          label="ニックネーム"
                          defaultValue={nickname}
                          variant="filled"
                          onChange={(event) => setNickname(event.target.value)}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          required
                          id="filled-required"
                          label="ご職業"
                          defaultValue={position}
                          variant="filled"
                          onChange={(event) => setPosition(event.target.value)}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <FormControl fullWidth required>
                          <InputLabel id="demo-simple-select-label">都道府県</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={prefecture.toString()}
                            label="都道府県"
                            onChange={handlePrefecture}
                          >
                            <MenuItem value={0}>None</MenuItem>
                            {prefectures.map((element, index) => (
                              <MenuItem key={index} value={index + 1}>{element}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          required
                          id="filled-disabled"
                          label="所属"
                          defaultValue={belongs}
                          variant="filled"
                          onChange={(event) => setBelongs(event.target.value)}
                        />
                        <FormHelperText>大学名・病院名・会社名等</FormHelperText>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">学年</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={grade.toString()}
                            label="学年"
                            onChange={handleGrade}
                          >
                            <MenuItem value={0}>None</MenuItem>
                            {grades.map((element, index) => (
                              <MenuItem key={index} value={index + 1}>{element}</MenuItem>
                            ))}
                          </Select>
                          <FormHelperText>学生の方のみ</FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">診療科</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={department.toString()}
                            label="診療科"
                            onChange={handleDepartment}
                          >
                            <MenuItem value={0}>None</MenuItem>
                            {departments.map((element, index) => (
                              <MenuItem key={index} value={index + 1}>{element}</MenuItem>
                            ))}
                          </Select>
                          <FormHelperText>医師の方のみ</FormHelperText>
                        </FormControl>
                      </Grid>
                     
                      <Grid>
                        <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
                          <FormLabel component="legend">このアプリをどこで知りましたか？</FormLabel>
                            <FormGroup>
                              {media.map((medium,index)=>(
                                <FormControlLabel
                                key={index}
                                control={
                                  <Checkbox 
                                  key={index}
                                  checked={mediaKind.indexOf(medium)!==-1} 
                                  onClick={()=>handleMedia(medium)} 
                                  name={medium}
                                  />
                                }
                                label={medium}
                                />
                              ))}
                            </FormGroup>
                          <FormHelperText>複数選択可能</FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={magazine === true}
                              onClick={() => setMagazine(!magazine)}
                              value="allowExtraEmails"
                              color="primary" />}
                          label="MNiSTからのメール案内を受け取る。"
                        />
                      </Grid>
                    </Grid>
                  </div>
                  <FormLabel component="legend">規約に同意しますか。</FormLabel>
                  <FormGroup>
                    {read ? (
                      <FormControlLabel
                        control={<Checkbox />}
                        onClick={() => checkstatus()}
                        label="はい"
                      />
                    ) : (
                      <FormControlLabel disabled control={<Checkbox />} label="はい" />
                    )}
                  </FormGroup>
                  <p>
                    規約は
                    <a href="https://sites.google.com/mnes.org/msta-support/%E3%83%9B%E3%83%BC%E3%83%A0/%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84"
                    rel="noreferrer" 
                    target="_blank" 
                    onClick={() => checkread()}>
                      こちら
                    </a>
                  </p>
                  {status ? (
                    <Grid display={'grid'}>
                      <Button
                        variant="contained"
                        style={{ color: "#e0f2f1", backgroundColor: "#009688" }}
                        onClick={() => createUser(data)}
                      >
                        登録する
                      </Button>
                      {warning ?
                        <Typography component="h5" variant="body1" color={'red'}>
                          必須事項が埋まっていません。
                        </Typography> : <div></div>
                      }
                    </Grid>
                  ) : (
                    <div></div>
                  )}
                </Box>
              </CardContent>
            </Card>
          </Container>
        </div>
      )}
    </div>
  );
}
